import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 65.18 49.28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.64 5.11c3.1-.4 10.8-1.5 13.6-2.1 2.7-.6 18.1-2.9 25.9-3 7.9-.1 7.5.4 7.6 1.9.2 1.5.9 2 0 3.4-1 1.4-2.6 2-5 2.9-4.4 1.7-23.7 6.9-26.3 8.2 4-.2 9.8-1.2 15.6-1.5 3.9-.1 4.4.7 4.7 2.5.4 1.7.5 2.6-2.1 3.6s-5.6 2.1-11.7 3.9c-8.5 2.5-13.6 3.6-19.9 6.4 3.5.4 9.2-.2 13.8 0 6.9.2 7.2 1 7.5 3.1.1 2 .4 2.6-2.5 4-2.9 1.2-8 2.6-10.8 3.2-2.9.6-13.7 3-15.8 3.5-1.9.5-3.5 2.6-6.4 3.6-3.2 1.1-4.6.6-5.7-1.6-.7-1.7 1.4-3.2 4-4 2.6-.7 10.6-2.5 14-3.4s10.1-2.7 12.3-3.6c-3 0-10.3.1-16 .2-3.4.1-4.6-.1-5.1-2.6s.5-3.4 3.5-4.2c3-1 7.5-3 10.3-4s11-3.9 13.2-4.4c-5.5-.1-17.8 2.6-20.9 3.2-2.5.5-2.7-.4-3.7-2-1-1.7.2-2.9 1.7-3.2 1.9-.5 5.5-2.2 10.6-4.2 4.1-1.6 9.8-3.4 14.1-4.7 4-1.4 10.8-3.7 13.1-4.6-1.7 0-9.8 1.1-15.2 1.9-5.2.7-14.3 2.6-15.7 3.1-1.4.5-3 .4-3.9-1.7s-.1-3.2 1.2-3.4",
      style: {"fill":"#ff8c00"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "QS-logo"}) } }